import {
  CalendarArrow,
  CheckList,
  Cross,
  Eye,
  EyeArrowCircle,
  ExclamationMarkCircle,
  Gear,
  Hourglass,
  Flash,
  FlagRacing,
  Play,
  Policy,
  Skip,
  StopCircle,
  Tick,
  ThumbUp,
  ThumbDown,
  Trash,
  Edit,
  QuestionMarkCircle,
} from "components/icons/generated";
import { IconComponent } from "types/Icon";
import { BadgeVariants } from "ds/components/BadgeNext/types";
import BadgeNext from "ds/components/BadgeNext";
import { RunState } from "types/generated";

import { prepareName } from "./helpers";

type RunHistoryEntryConfig = {
  icon: IconComponent;
  variant?: BadgeVariants;
};

export const RUN_STATES: Record<RunState, RunHistoryEntryConfig> = {
  [RunState.Applying]: { icon: Play, variant: "blue" },
  [RunState.Canceled]: { icon: Cross, variant: "red" },
  [RunState.Confirmed]: { icon: ThumbUp, variant: "gray" },
  [RunState.Destroying]: { icon: Trash, variant: "blue" },
  [RunState.Discarded]: { icon: ThumbDown, variant: "red" },
  [RunState.Failed]: { icon: ExclamationMarkCircle, variant: "red" },
  [RunState.Finished]: { icon: Tick, variant: "green" },
  [RunState.Initializing]: { icon: Gear, variant: "blue" },
  [RunState.Pending]: { icon: Policy, variant: "blue" },
  [RunState.PendingReview]: { icon: EyeArrowCircle, variant: "yellow" },
  [RunState.Performing]: { icon: Flash, variant: "blue" },
  [RunState.Planning]: { icon: Edit, variant: "blue" },
  [RunState.Preparing]: { icon: CheckList, variant: "blue" },
  [RunState.PreparingApply]: { icon: CheckList, variant: "blue" },
  [RunState.PreparingReplan]: { icon: CheckList, variant: "blue" },
  [RunState.Queued]: { icon: Hourglass, variant: "gray" },
  [RunState.Ready]: { icon: FlagRacing, variant: "gray" },
  [RunState.ReplanRequested]: { icon: CalendarArrow, variant: "gray" },
  [RunState.Skipped]: { icon: Skip, variant: "gray" },
  [RunState.Stopped]: { icon: StopCircle, variant: "red" },
  [RunState.Unconfirmed]: { icon: Eye, variant: "yellow" },
  [RunState.Unknown]: { icon: QuestionMarkCircle, variant: "white" },
};

type RunStateBadgeProps = {
  state: RunState;
  className?: string;
  textEllipsis?: boolean;
};

const RunStateBadge = ({ state, className, textEllipsis }: RunStateBadgeProps) => {
  if (!RUN_STATES[state]) {
    return null;
  }

  const text = prepareName(state);

  return (
    <BadgeNext
      textEllipsis={textEllipsis}
      startIcon={RUN_STATES[state].icon}
      variant={RUN_STATES[state].variant || "gray"}
      type="strong"
      className={className}
      text={text}
    />
  );
};

export default RunStateBadge;
